import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, signal } from '@angular/core';

interface Scope {
	loading: boolean;
}

@Component({
	selector: 'ms-tab',
	templateUrl: './ms-tab.component.html',
	styleUrls: ['./ms-tab.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsTabComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() active = false;

	scope: Scope = {
		loading: false,
	};

	/**
	 * Constructor
	 */
	constructor() {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
